import type { LayoutPreset } from './types';

export const DEFAULT_LAYOUT_PRESETS: LayoutPreset[] = [
  {
    id: 'full',
    label: 'Полный фон',
    regions: [{ x: 0, y: 0, w: 1, h: 1 }],
  },
  {
    id: 'split-lr',
    label: 'Разделение лево / право',
    regions: [
      { x: 0, y: 0, w: 0.5, h: 1 },
      { x: 0.5, y: 0, w: 0.5, h: 1 },
    ],
  },
  {
    id: 'split-tb',
    label: 'Разделение верх / низ',
    regions: [
      { x: 0, y: 0, w: 1, h: 0.5 },
      { x: 0, y: 0.5, w: 1, h: 0.5 },
    ],
  },
  {
    id: 'quadrants',
    label: 'Четыре квадранта',
    regions: [
      { x: 0, y: 0, w: 0.5, h: 0.5 },
      { x: 0.5, y: 0, w: 0.5, h: 0.5 },
      { x: 0, y: 0.5, w: 0.5, h: 0.5 },
      { x: 0.5, y: 0.5, w: 0.5, h: 0.5 },
    ],
  },
  {
    id: 'three-cols',
    label: 'Три колонки',
    regions: [
      { x: 0, y: 0, w: 1 / 3, h: 1 },
      { x: 1 / 3, y: 0, w: 1 / 3, h: 1 },
      { x: 2 / 3, y: 0, w: 1 / 3, h: 1 },
    ],
  },
  {
    id: 'three-rows',
    label: 'Три строки',
    regions: [
      { x: 0, y: 0, w: 1, h: 1 / 3 },
      { x: 0, y: 1 / 3, w: 1, h: 1 / 3 },
      { x: 0, y: 2 / 3, w: 1, h: 1 / 3 },
    ],
  },
  {
    id: 'two-top-one-bottom',
    label: 'Два сверху, один снизу',
    regions: [
      { x: 0, y: 0, w: 0.5, h: 0.5 },
      { x: 0.5, y: 0, w: 0.5, h: 0.5 },
      { x: 0, y: 0.5, w: 1, h: 0.5 },
    ],
  },
  {
    id: 'one-top-two-bottom',
    label: 'Один сверху, два снизу',
    regions: [
      { x: 0, y: 0, w: 1, h: 0.5 },
      { x: 0, y: 0.5, w: 0.5, h: 0.5 },
      { x: 0.5, y: 0.5, w: 0.5, h: 0.5 },
    ],
  },
  {
    id: 't-shape',
    label: 'Т-образный',
    regions: [
      { x: 0, y: 0, w: 1, h: 0.4 },
      { x: 0, y: 0.4, w: 0.5, h: 0.6 },
      { x: 0.5, y: 0.4, w: 0.5, h: 0.6 },
    ],
  },
  {
    id: 'left-big-two-right',
    label: 'Большой слева, два справа',
    regions: [
      { x: 0, y: 0, w: 0.6, h: 1 },
      { x: 0.6, y: 0, w: 0.4, h: 0.5 },
      { x: 0.6, y: 0.5, w: 0.4, h: 0.5 },
    ],
  },
  {
    id: 'right-big-two-left',
    label: 'Большой справа, два слева',
    regions: [
      { x: 0.4, y: 0, w: 0.6, h: 1 },
      { x: 0, y: 0, w: 0.4, h: 0.5 },
      { x: 0, y: 0.5, w: 0.4, h: 0.5 },
    ],
  },
  {
    id: 'top-big-two-bottom',
    label: 'Большой сверху, два снизу',
    regions: [
      { x: 0, y: 0, w: 1, h: 0.6 },
      { x: 0, y: 0.6, w: 0.5, h: 0.4 },
      { x: 0.5, y: 0.6, w: 0.5, h: 0.4 },
    ],
  },
];
